import React from 'react';
import { Button } from '@chakra-ui/react';

export const CustomButton = ({ children, variant = "solid", colorScheme = "blue", ...props }) => {
    return (
        <Button 
            variant={variant}
            colorScheme={colorScheme}
            borderRadius="8px"
            fontWeight="600"
            px={8}
            py={6}
            bg={variant === "solid" ? "blue.600" : undefined}
            bgGradient={variant === "solid" ? "linear(to-r, blue.500, blue.600)" : undefined}
            color={variant === "solid" ? "white" : undefined}
            _hover={{
                bgGradient: variant === "solid" ? "linear(to-r, blue.600, blue.700)" : undefined,
                transform: "translateY(-1px)",
                shadow: "md"
            }}
            _active={{
                transform: "translateY(0)",
                shadow: "none"
            }}
            transition="all 0.2s"
            {...props}
        >
            {children}
        </Button>
    );
}
